import styled from 'styled-components';

export const CookiesContainer = styled.div`
  box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.10);
  bottom: 24px;
  left: 24px;
  right: 24px;
  background-color: #FFFFFF;
  position: fixed;
  z-index: 50;
  display: flex;
  align-items: center;
  border-radius: 8px;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px;

  @media (max-width: 767px) {
    left: 16px;
    right: 16px;
  }
`;

export const CookiesDescription = styled.div`
  font-size: 14px;
  color: #263B9E;
  line-height: 20px;
  font-family: sans-serif;
  min-width: 0;
  flex: 1 1 12rem;
`;

export const CookiesButton = styled.button<{ bgColor: string }>`
  width: fit-content;
  flex-shrink: 0;
  margin-left: auto;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 12px;
  color: #FFFFFF;
  background-color: ${({ bgColor }) => bgColor};
  font-family: sans-serif;
`
